import React, { memo, useCallback, useState } from "react";
import MembershipContent from "../../Components/MembershipComponents/MembershipContent/MembershipContent";
import MembershipOrder from "../../Components/MembershipComponents/MembershipOrder/MembershipOrder";
import MembershipSidebar from "../../Components/MembershipComponents/MembershipSidebar/MembershipSidebar";

const Memberships = () => {
  const initialSteps = [
    {
      stepName: "Welcome",
      isActive: false,
    },
    {
      stepName: "Place of Treatment",
      isActive: false,
    },
    {
      stepName: "Treatment Options",
      isActive: true,
      subSteps: [
        {
          subStepName: "Massage Therapy",
          isActive: true,
        },
        {
          subStepName: "Physiotherapy",
          isActive: false,
        },
        {
          subStepName: "Acupuncture",
          isActive: false,
        },
        {
          subStepName: "Performance Mobility Therapy",
          isActive: false,
        },
        {
          subStepName: "Body Transformation",
          isActive: false,
        },
        {
          subStepName: "Cupping Therapy",
          isActive: false,
        },
        {
          subStepName: "Advanced Electro Muscular Therapy",
          isActive: false,
        },
        {
          subStepName: "Manipulative Medicine",
          isActive: false,
        },
      ],
    },
    {
      stepName: "Summary",
      isActive: false,
    },
  ];
  const [steps] = useState(initialSteps || []);
  const [location, setLocation] = useState({
    name: "",
    price: 0,
  });
  const [isStepOpen, setIsStepOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [subActiveStep, setSubActiveStep] = useState(0);
  const [massageCardsData, setMassageCardsData] = useState([
    {
      name: "Sports Massage",
      headNeck: {
        price: 67,
        isChecked: false,
      },
      fullBack: {
        price: 67,
        isChecked: false,
      },
      lowerBack: {
        price: 67,
        isChecked: false,
      },
      thighLegs: {
        price: 67,
        isChecked: false,
      },
      frequency: "once",
      charge: 0,
    },
    {
      name: "Deep tissue massage",
      headNeck: {
        price: 67,
        isChecked: false,
      },
      fullBack: {
        price: 67,
        isChecked: false,
      },
      lowerBack: {
        price: 67,
        isChecked: false,
      },
      thighLegs: {
        price: 67,
        isChecked: false,
      },
      frequency: "once",
      charge: 0,
    },
    {
      name: "Turkish Inspired Body Scrub",
      headNeck: {
        price: 67,
        isChecked: false,
      },
      fullBack: {
        price: 67,
        isChecked: false,
      },
      lowerBack: {
        price: 67,
        isChecked: false,
      },
      thighLegs: {
        price: 67,
        isChecked: false,
      },
      frequency: "once",
      charge: 0,
    },
    {
      name: "Swedish Mix therapy",
      headNeck: {
        price: 67,
        isChecked: false,
      },
      fullBack: {
        price: 67,
        isChecked: false,
      },
      lowerBack: {
        price: 67,
        isChecked: false,
      },
      thighLegs: {
        price: 67,
        isChecked: false,
      },
      frequency: "once",
      charge: 0,
    },
  ]);
  const [performanceData, setPerformanceData] = useState([
    {
      focusArea: "Neck & Shoulder Stretch",
      therapyDuration: "15 mins",
      price: 17,
      isChecked: false,
    },
    {
      focusArea: "Back, Chest & Shoulder Stretch",
      therapyDuration: "20 mins",
      price: 27,
      isChecked: false,
    },
    {
      focusArea: "Full Body",
      therapyDuration: "30 mins",
      price: 37,
      isChecked: false,
    },
  ]);
  const [bodyTransformationData, setBodyTransformationData] = useState([
    {
      package: "1 to 1 Personal Training Session",
      sessions: 1,
      price: 75,
      defaultPrice: 75,
      isChecked: false,
    },
    {
      package: "Coaching Sessions (8 per month)",
      sessions: 1,
      price: 547,
      defaultPrice: 547,
      isChecked: false,
    },
    {
      package: "Coaching Sessions (12 per month)",
      sessions: 1,
      price: 767,
      defaultPrice: 767,
      isChecked: false,
    },
    {
      package: "Add On: Body analysis",
      isChecked: false,
      price: 45,
      defaultPrice: 45,
    },
  ]);
  const [cuppingTherapyData, setCuppingTherapydata] = useState([
    {
      focusArea: "Back",
      price: 57,
      isChecked: false,
    },
    {
      focusArea: "Shoulders",
      price: 57,
      isChecked: false,
    },
    {
      focusArea: "Thighs",
      price: 57,
      isChecked: false,
    },
  ]);
  const [advancedElectroMuscularData, setAdvancedElectroMuscularData] =
    useState([
      {
        focusArea: "Arms & Abs",
        duration: "20 mins",
        frequency: "once",
        price: 47,
        isChecked: false,
      },
      {
        focusArea: "Hamstring & Glutes",
        duration: "20 mins",
        frequency: "once",
        price: 47,
        isChecked: false,
      },
      {
        focusArea: "Abs & Quads",
        duration: "20 mins",
        frequency: "once",
        price: 47,
        isChecked: false,
      },
      {
        focusArea: "Abs, Glutes, Hamstrings, & Quads",
        duration: "30 mins",
        frequency: "once",
        price: 97,
        isChecked: false,
      },
    ]);
  const [manipulativeTherapyData, setManipulativeTherapyData] = useState([
    {
      type: "Consulation",
      price: 37,
      isChecked: false,
    },
    {
      type: "Treatment",
      price: 57,
      isChecked: false,
    },
  ]);
  const [physiotherapyData, setPhysiotherapyData] = useState([
    {
      type: "Consulation",
      price: 37.5,
      isChecked: false,
    },
    {
      type: "Treatment",
      price: 57,
      isChecked: false,
    },
  ]);
  const [acupunctureData, setAcupunctureData] = useState([
    {
      type: "Consulation",
      price: 37,
      isChecked: false,
    },
    {
      type: "Treatment",
      price: 57,
      isChecked: false,
    },
  ]);

  const handleIncrementSession = (index) => {
    if (bodyTransformationData[index]?.sessions < 0) return;
    const data = bodyTransformationData?.map((item, i) => {
      if (i !== index) return item;
      return {
        ...item,
        sessions: item?.sessions + 1,
        price: item?.defaultPrice * (item?.sessions + 1),
      };
    });
    setBodyTransformationData(data);
  };
  const handleDecrementSession = (index) => {
    if (bodyTransformationData[index]?.sessions === 1) return;
    const data = bodyTransformationData?.map((item, i) => {
      if (i !== index) return item;
      return {
        ...item,
        sessions: item?.sessions - 1,
        price: item?.defaultPrice * (item?.sessions - 1),
      };
    });
    setBodyTransformationData(data);
  };

  const handleNextStep = useCallback(() => {
    if (activeStep === steps?.length - 1) return;
    if (activeStep !== 2) {
      setActiveStep(activeStep + 1);
    }
    if (subActiveStep === steps[2]?.subSteps?.length - 1) {
      setActiveStep(activeStep + 1);
      return;
    }
    if (activeStep === 2) {
      setSubActiveStep(subActiveStep + 1);
    }
  }, [activeStep, steps, subActiveStep]);
  const handleBackStep = useCallback(() => {
    if (activeStep === 3) {
      setActiveStep(activeStep - 1);
      return;
    }
    if (activeStep === 0) return;
    if (activeStep === 2 && subActiveStep !== 0) {
      setSubActiveStep(subActiveStep - 1);
    }
    if (activeStep <= 2 && subActiveStep === 0) {
      setActiveStep(activeStep - 1);
    }
  }, [activeStep, subActiveStep]);

  return (
    <div className="h-screen flex">
      <div
        className={
          isStepOpen
            ? `w-[270px] sm:w-[382px] absolute overflow-hidden lg:overflow-visible z-[1] transition-all`
            : `w-[40px] lg:w-[382px] overflow-hidden transition-all`
        }
      >
        <MembershipSidebar
          steps={steps}
          activeStep={activeStep}
          subActiveStep={subActiveStep}
          setActiveStep={setActiveStep}
          setSubActiveStep={setSubActiveStep}
          isOpen={isStepOpen}
          setIsOpen={setIsStepOpen}
        />
      </div>
      <div className="w-full overflow-auto">
        <MembershipContent
          setActiveStep={setActiveStep}
          handleNextStep={handleNextStep}
          handleBackStep={handleBackStep}
          totalSteps={steps?.length}
          activeStep={activeStep}
          subActiveStep={subActiveStep}
          setSubActiveStep={setSubActiveStep}
          setLocation={setLocation}
          location={location}
          massageCardsData={massageCardsData}
          setMassageCardsData={setMassageCardsData}
          performanceData={performanceData}
          setPerformanceData={setPerformanceData}
          bodyTransformationData={bodyTransformationData}
          setBodyTransformationData={setBodyTransformationData}
          handleIncrementSession={handleIncrementSession}
          handleDecrementSession={handleDecrementSession}
          cuppingTherapyData={cuppingTherapyData}
          setCuppingTherapydata={setCuppingTherapydata}
          advancedElectroMuscularData={advancedElectroMuscularData}
          setAdvancedElectroMuscularData={setAdvancedElectroMuscularData}
          manipulativeTherapyData={manipulativeTherapyData}
          setManipulativeTherapyData={setManipulativeTherapyData}
          physiotherapyData={physiotherapyData}
          setPhysiotherapyData={setPhysiotherapyData}
          acupunctureData={acupunctureData}
          setAcupunctureData={setAcupunctureData}
        />
        {activeStep !== 0 && (
          <MembershipOrder
            location={location}
            massageCardsData={massageCardsData}
            performanceData={performanceData}
            bodyTransformationData={bodyTransformationData}
            cuppingTherapyData={cuppingTherapyData}
            advancedElectroMuscularData={advancedElectroMuscularData}
            manipulativeTherapyData={manipulativeTherapyData}
            physiotherapyData={physiotherapyData}
            acupunctureData={acupunctureData}
          />
        )}
      </div>
    </div>
  );
};

export default memo(Memberships);
